import {
  Inserter,
  PartMenu,
  PartAdmin,
  PartFrontlogo,
  OverlayIndex,
  Wrapper,
  Link,
  OverlayOpen,
  PartScrollPos,
  PartScrollTopOnNavigate,
  DragAndDropContext,
  Icon,
  Image,
  PartIconmenu,
} from "nystem-components";

import React from "react";

import "./index.css";
import "./part/iconmenu.css";

let loaded = false;

const Index = () => (
  <DragAndDropContext>
    <>
      <main className="body">
        <PartScrollTopOnNavigate />
        <OverlayIndex>
          <Wrapper key="menu">
            <PartMenu />
          </Wrapper>
        </OverlayIndex>
        <Inserter match="/">
          <PartFrontlogo />
          <PartIconmenu />
          <PartScrollPos>
            {({ height }) => (
              <div style={{ height, transition: "all 500ms" }} />
            )}
          </PartScrollPos>
          <PartScrollPos>
            {({ scrollTop }) => {
              if (scrollTop) loaded = true;
              if (!loaded) return null;
              return <Inserter key="/page/all" match="/" source="/page/all" />;
            }}
          </PartScrollPos>
        </Inserter>
        <div className="icon-menu-top">
          <OverlayOpen overlayId="menu">
            <div>
              <Icon
                className="h-12 w-12 p-2 sm:w-14 sm:h-14 mb-6 bg-white rounded-xl bg-opacity-20"
                icon="bars"
              />
            </div>
          </OverlayOpen>
        </div>
        <Inserter exclude="/">
          <Link renderAs="div" to="/" className="center">
            <div className="page-logo-box">
              <Image src="/image/150x200/logo.png" className="w-full h-full" alt="Logo" />
            </div>
          </Link>
        </Inserter>
        <Inserter match="/blog*" className="blog container" />
        <Inserter match="/*" source="/page/render/*" />
        <PartAdmin />
      </main>
    </>
  </DragAndDropContext>
);
export default Index;
